/**
 * @generated SignedSource<<70051d1814e5f6273e5804bb61994e31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type previewContent_AtlassianConversationAssistantPreviewCard$data = {
  readonly avatar: {
    readonly xsmall: string | null;
  } | null;
  readonly id: string;
  readonly issueTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldsConfiguration: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly __typename: string;
              readonly fieldId: string;
              readonly " $fragmentSpreads": FragmentRefs<"field_AtlassianConversationAssistantPreviewCard" | "withFieldLabel_AtlassianConversationAssistantPreviewCard">;
            } | null;
          } | null> | null;
        } | null;
        readonly issueTypeId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"JiraIssueTypeIcon_Platform">;
      } | null;
    } | null> | null;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "previewContent_AtlassianConversationAssistantPreviewCard";
};
export type previewContent_AtlassianConversationAssistantPreviewCard$key = {
  readonly " $data"?: previewContent_AtlassianConversationAssistantPreviewCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"previewContent_AtlassianConversationAssistantPreviewCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "previewContent_AtlassianConversationAssistantPreviewCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "xsmall"
        }
      ]
    },
    {
      "concreteType": "JiraIssueTypeConnection",
      "kind": "LinkedField",
      "name": "issueTypes",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "issueTypeId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "JiraIssueTypeIcon_Platform"
                },
                {
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fieldsConfiguration",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "__typename"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "fieldId"
                            },
                            {
                              "kind": "FragmentSpread",
                              "name": "field_AtlassianConversationAssistantPreviewCard"
                            },
                            {
                              "kind": "FragmentSpread",
                              "name": "withFieldLabel_AtlassianConversationAssistantPreviewCard"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "1fab6b10b4450c713cca747d62df8a1c";

export default node;
